import {
  initNativeEmbedEditorPlugin,
  sendContentReady,
} from '@databases/native-embed-editor-plugin';
import { container } from '@databases/service-container';

/**
 * Startup module for the NATIVE_EMBED_EDITOR_PLUGIN mode.
 *
 * Initializes the iframe bridge client for editor-plugin communication with
 * the parent (reads query params, sets up command listeners), then wires
 * `databaseUILoaded` to signal content readiness to the host on every
 * database load — including the initial load and subsequent identity changes.
 */
export function initNativeEmbedEditorPluginStartup(): void {
  initNativeEmbedEditorPlugin();

  container.resolve('EventBus').on('databaseUILoaded', () => {
    sendContentReady();
  });
}
